import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import {MatDialogModule} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';

import { EstatusEncuestaComponent } from "./estatus-encuesta.component";
import { ModalConfirmacionComponent } from "./modal-confirmacion/modal-confirmacion.component";

@NgModule({
  declarations: [EstatusEncuestaComponent, ModalConfirmacionComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule
  ],
  entryComponents: [
    ModalConfirmacionComponent
  ]
})
export class EstatusEncuestaModule { }
